<template>
  <div style="display:flex;flex-direction:column;">
    <div>
      <hi-datatable-search
        v-if="searchBar"
        :alphabetic="['name', 'midName', 'surname']"
        :wild="['name', 'midName', 'surname']"
        :labels="searchLabelType"
        @search="onSearch"
      ></hi-datatable-search>
    </div>
    <!--    use position relative wrapper & position absolute datatable to solve flex-grow does shrink size problem-->
    <div
      ref="container"
      style="flex-grow:1;overflow: hidden;position:relative"
      v-resize="onResize"
    >
      <v-data-table
        style="height:100%;position: absolute;width:100%"
        fixed-header
        single-select
        :headers="computedHeaders"
        :items="items"
        item-key="id"
        :search="search"
        :custom-filter="customFilter"
        :items-per-page="itemsPerPage"
        :height="tableHeight"
        :sort-by="sortByArr"
        :sort-desc="sortOrderArr"
        mustSort
        no-data-text="Sorry, No Data Found..."
        no-results-text="Sorry, No Search Result..."
        :footer-props="{
          itemsPerPageOptions: [20, 25, 30, 35, 40, 50, 100, -1]
        }"
        @update:items-per-page="updateItemPerPage"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              :class="{ selected: item.id === selectedItemId }"
              @click="selectRow(key, item)"
              v-for="(item, key) in items"
              :key="item.id"
            >
              <td
                v-for="header in computedHeaders"
                :key="header.value"
                :style="{
                  width: header.width
                }"
                :class="{
                  dense: header.dense,
                  bold: header.bold,
                  uppercase: header.uppercase || header.uppderCase,
                  capitalize: header.capitalize
                }"
              >
                <v-badge
                  v-if="header.badge"
                  dot
                  color="#FFC0CB"
                  :value="header.badge(item)"
                  ><span
                    v-html="renderCell(header, item)"
                    :class="header.classes"
                  ></span
                ></v-badge>
                <span
                  v-html="renderCell(header, item)"
                  v-if="!header.badge"
                  :class="header.classes"
                ></span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Hivue from "../hive/Hivue";
import HiDatatableSearch from "@/components/HiDatatableSearch";
export default {
  name: "HiDatatable",
  components: {
    HiDatatableSearch
  },
  props: {
    /**
     * Difference with v-datatable headers
     *    renderer: function(itemVal){return displayVal//displayVal can be null},
     *    dense: use smaller font-size
     *    bold: use bold font,
     *    upppercase | upperCase
     *    capitalize
     */
    headers: {
      type: Array,
      required: true
    },
    sortBy: {
      type: String
    },
    items: {
      type: Array,
      required: true
    },
    desc: {
      type: Boolean,
      default: false
    },
    /**
     * uniqueId for remembering settings
     */
    localId: {
      type: String,
      default: "hive-datatable"
    },
    searchLabelType: {
      type: String,
      default: "leads"
    },
    searchBar: {
      type: Boolean
    }
  },
  data() {
    return {
      selectedItemId: null,
      search: null,
      itemsPerPage: 50,
      tableHeight: null,
      tableWidth: null,
      /** to change sortBy & desc to data instead of prop to preserve the sorting when displaying data changed.*/
      sortByArr: [this.sortBy],
      sortOrderArr: [this.desc],
      customFilter: null
    };
  },
  methods: {
    onResize() {
      setTimeout(() => {
        let container = this.$refs.container;
        this.tableWidth = Hivue.width(container);
        let containerHeight = Hivue.height(container);
        let footer = Hivue.query(container, ".v-data-footer");
        this.tableHeight = containerHeight - footer.clientHeight;
        // console.log(this.tableHeight);
      }, 100);
    },
    updateItemPerPage(val) {
      localStorage.setItem(this.localId + "-itemsPerPage", val);
      this.itemsPerPage = val;
    },
    selectRow(idx, item) {
      this.selectedItemId = item.id;
      this.$emit("select", item);
    },
    renderCell(header, item) {
      if (!item) return "N/A";
      let val;
      if (header.renderer) {
        val = header.renderer(item);
      } else {
        val = item[header.value];
      }
      if (!val) return `<span class="null">Null</span>`;
      return val;
    },
    onSearch(term, func) {
      this.customFilter = func;
      this.search = term;
    }
  },
  mounted() {
    const itemsPerPage = localStorage.getItem(this.localId + "-itemsPerPage");
    if (itemsPerPage) {
      this.itemsPerPage = parseInt(itemsPerPage);
    }
  },
  computed: {
    computedHeaders() {
      const headers = [];
      this.headers.forEach(h => {
        if (!h.hidden) {
          headers.push(h);
        } else if (this.tableWidth > h.hidden) {
          headers.push(h);
        }
      });
      return headers;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-data-table ::v-deep .v-data-footer {
  margin-right: 0;
}
::v-deep .v-data-table {
  margin-right: 0;
  background-color: $light1;
}
::v-deep th {
  background: $light5 !important;
}
::v-deep tr.selected {
  background: white;
}
::v-deep tr {
  transition: all 0.3s;
  cursor: default;
  background-color: $light1;
}
::v-deep th.active {
  color: $gold-dark !important;
}
::v-deep th.active i {
  color: $gold-dark !important;
}
::v-deep tr:hover {
  background-color: #fcfcfc !important;
}
::v-deep .dense {
  font-size: 0.7em !important;
}
::v-deep .bold {
  font-weight: bold !important;
}
::v-deep .null {
  font-size: 0.7em !important;
  opacity: 0.3;
  font-style: italic;
}
</style>
